import { render, staticRenderFns } from "./BasketDelBtn.vue?vue&type=template&id=0dd52a1b&scoped=true&"
import script from "./BasketDelBtn.vue?vue&type=script&lang=js&"
export * from "./BasketDelBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd52a1b",
  null
  
)

export default component.exports